import { render, staticRenderFns } from "./deviceWorkerDealArrive.vue?vue&type=template&id=4bde630a&scoped=true&"
import script from "./deviceWorkerDealArrive.vue?vue&type=script&lang=js&"
export * from "./deviceWorkerDealArrive.vue?vue&type=script&lang=js&"
import style0 from "./deviceWorkerDealArrive.vue?vue&type=style&index=0&id=4bde630a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bde630a",
  null
  
)

export default component.exports